import {
    useEntityDerive,
    UseEntityDeriveProps,
    useItemGroupEntityDerive,
} from 'src/hooks/useEntityDerive'
import { ItemGroupEntity } from 'src/models/dto/activities/ItemGroupDTO'

export interface WithEntityDeriveProps<T, R> extends UseEntityDeriveProps<T, R> {
    children: (value: R) => JSX.Element
}

export const WithEntityDerive = <T, R>({
    children: render,
    ...rest
}: WithEntityDeriveProps<T, R>) => {
    const value = useEntityDerive<T, R>(rest)
    return render(value)
}

export type WithItemGroupEntityDeriveProps<R> = {
    workflowEntityId: string
    moduleEntityId: string
    derive: (item: ItemGroupEntity) => R
    children: (value: R) => JSX.Element
}

export const WithItemGroupEntityDerive = <R,>({
    workflowEntityId,
    moduleEntityId,
    derive,
    children: render,
}: WithItemGroupEntityDeriveProps<R>) => {
    const value = useItemGroupEntityDerive({ workflowEntityId, moduleEntityId, derive })
    return render(value)
}
